var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIconMis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 35,
    rx: 7.5,
    fill: "#7BD755",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 35,
    rx: 7.5,
    stroke: "#7BD755"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H12V23H28V18H30V23C30 24.11 29.11 25 28 25H12C10.9 25 10 24.11 10 23V18ZM20 21L25.55 15.54L24.13 14.13L21 17.25V8H19V17.25L15.88 14.13L14.46 15.55L20 21Z",
    fill: "#7BD755"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconMis);
export default __webpack_public_path__ + "static/media/DownloadIconMIS.ad37c7de9624c01845497684e6d0a42e.svg";
export { ForwardRef as ReactComponent };